import { useMemo } from 'react'

import { Delete } from '@workwave-tidal/core/icons'

import { preview } from '@/components/form/preview'
import { useDeleteUserConfirmationModal } from '../modals/DeleteUserConfirmationModal'

import { useTexts } from './hooks/useTexts'
import { useOnCloseUserDetails } from './hooks/useOnCloseUserDetails'
import { useOnDeleteUsers } from './hooks/useOnDeleteUsers'

type Props = {
  users: uui.domain.client.rm.RouteManagerUser[]
  selection: string[]
}

export function ViewUsers(props: Props) {
  const { users, selection } = props
  const texts = useTexts()

  const onCloseUserDetails = useOnCloseUserDetails()
  const onDeleteUsers = useOnDeleteUsers()

  const type = useMemo(() => {
    const usersTypes = new Set(users.map(user => user.type))

    return usersTypes.size === 1 ? users[0].type : texts.mixed
  }, [texts, users])
  const role = `${type[0].toUpperCase()}${type.substring(1)}`

  const { Modal: DeleteUserConfirmationModal } = useDeleteUserConfirmationModal()

  return (
    <preview.Root
      applyPendingFitMapOnMount
      header={
        <preview.Header title={texts.title(users.length)} onClose={onCloseUserDetails}>
          <preview.ActionBar>
            <preview.ActionBarItem
              icon={<Delete />}
              onClick={onDeleteUsers}
              label={texts.tooltips.delete}
              tooltip={texts.tooltips.delete}
              testId="user-delete"
              data-trackid="user-delete"
              disableWhenReadOnly
            />
          </preview.ActionBar>
        </preview.Header>
      }
    >
      <preview.Field label={texts.labels.role}>{role}</preview.Field>

      <DeleteUserConfirmationModal userIds={selection} />
    </preview.Root>
  )
}
